<!-- Seitenrahmen, Bedienleiste und Ansichtswechsel wie die Teamplanung (shared/resource-page-toolbar.css) -->
<div class="v2-page">

  <!-- Seitenkopf -->
  <header class="page-header">
    <div>
      <h1>Mein Kalender</h1>
      <p>Meine Planungstermine, Outlook-Vorschläge und genehmigten Abwesenheiten</p>
    </div>

    <div class="header-actions">
      <button mat-flat-button color="primary" (click)="addAppointment()" [disabled]="!context || saving">
        <mat-icon>add</mat-icon>
        Termin hinzufügen
      </button>
    </div>
  </header>

  <section class="planning-card">

    <!-- Bedienleiste: Datumsnavigation und Ansichtswechsel -->
    <div class="filter-toolbar">

      <div class="filter-toolbar-left">
        <!-- Ausgeblendete Outlook-Termine (Liste zum Wiederherstellen) -->
        <button mat-stroked-button type="button" class="hidden-events-btn" *ngIf="hasCalendarFeed"
          (click)="openHiddenDialog()" matTooltip="Ausgeblendete Outlook-Termine anzeigen und wieder einblenden">
          <mat-icon>visibility_off</mat-icon>
          <span>Ausgeblendete Termine</span>
          <span class="hidden-events-count" *ngIf="hiddenCount > 0">{{ hiddenCount }}</span>
        </button>
      </div>

      <div class="filter-toolbar-right">

        <!-- Datumsnavigation -->
        <div class="week-navigation">
          <button mat-icon-button (click)="move(-1)" [attr.aria-label]="'Vorheriges ' + periodNoun">
            <mat-icon>chevron_left</mat-icon>
          </button>

          <strong>{{ periodLabel }}</strong>

          <button mat-icon-button (click)="move(1)" [attr.aria-label]="'Nächstes ' + periodNoun">
            <mat-icon>chevron_right</mat-icon>
          </button>

          <button mat-stroked-button (click)="goToday()">
            Heute
          </button>
        </div>

        <!-- Ansichtswechsel -->
        <div class="view-switch">
          <button type="button" [class.active]="view === 'week'" (click)="setView('week')">Woche</button>
          <button type="button" [class.active]="view === 'month'" (click)="setView('month')">Monat</button>
          <button type="button" [class.active]="view === 'quarter'" (click)="setView('quarter')">Quartal</button>
          <button type="button" [class.active]="view === 'year'" (click)="setView('year')">Jahr</button>
        </div>

      </div>
    </div>

    <mat-progress-bar mode="indeterminate" *ngIf="loading && context" class="load-bar"></mat-progress-bar>

    <div class="calendar-body">
      <div *ngIf="loading && !context" class="calendar-loading"><mat-spinner diameter="20"></mat-spinner> Termine werden geladen …</div>
      <p *ngIf="error" role="alert" class="calendar-error">{{ error }}</p>
      <p *ngIf="outlookWarning" class="calendar-hint warn">{{ outlookWarning }}</p>

      <ng-container *ngIf="context && !error">
        <!-- Woche -->
        <app-resource-my-calendar-week *ngIf="view === 'week'" [days]="weekDays" [items]="visibleItems" [today]="today"
          [selectable]="!saving" (itemClick)="onItemClick($event)" (slotSelect)="onSlotSelect($event)">
        </app-resource-my-calendar-week>

        <!-- Monat, Quartal, Jahr -->
        <div class="month-blocks" *ngIf="view !== 'week'" [ngClass]="view">
          <app-resource-my-calendar-month *ngFor="let block of monthBlocks; trackBy: trackMonth"
            [month]="block.start" [days]="block.days" [items]="visibleItems" [today]="today" [selectable]="!saving"
            [density]="view === 'month' ? 'normal' : view === 'quarter' ? 'compact' : 'mini'"
            [heading]="view === 'month' ? '' : block.label"
            (itemClick)="onItemClick($event)" (slotSelect)="onSlotSelect($event)" (dayOpen)="openDay($event)">
          </app-resource-my-calendar-month>
        </div>
      </ng-container>
    </div>
  </section>

  <p class="calendar-note">
    Outlook-Termine sind nur Vorschläge: Erst durch „In Planung übernehmen“ werden sie zu internen Terminen.
    Änderungen und Löschungen betreffen ausschließlich die Ressourcenplanung – Outlook bleibt unverändert.
  </p>
</div>

<!-- Details: Outlook-Vorschlag, Abwesenheit, zugewiesener Termin -->
<div class="v2-modal-overlay" *ngIf="detail" (click)="closeDetail()">
  <div class="detail-card" role="dialog" aria-modal="true" [attr.aria-label]="detail.title" (click)="$event.stopPropagation()">
    <div class="detail-head">
      <span class="detail-kind" [ngClass]="detail.kind" [style.--item-color]="detail.color">{{ kindLabel(detail) }}</span>
      <button mat-icon-button (click)="closeDetail()" aria-label="Schließen"><mat-icon>close</mat-icon></button>
    </div>
    <h3>{{ detail.title }}</h3>
    <p class="detail-line"><mat-icon>event</mat-icon>{{ formatRange(detail) }}</p>
    <p class="detail-line" *ngIf="detail.kind !== 'outlook' && detail.label"><mat-icon>label</mat-icon>{{ detail.label }}</p>
    <p class="detail-line" *ngIf="detail.location"><mat-icon>place</mat-icon>{{ detail.location }}</p>

    <p class="calendar-hint" *ngIf="detail.kind === 'outlook'">
      Dieser Termin stammt aus deinem Outlook-Kalender und ist noch nicht in der Planung. Outlook wird durch keine
      Aktion verändert.
    </p>
    <p class="calendar-hint" *ngIf="detail.kind === 'absence'">
      Abwesenheiten werden im Bereich „Abwesenheiten“ beantragt und verwaltet.
    </p>
    <p class="calendar-hint" *ngIf="detail.kind === 'assignment'">
      Dieser Termin wurde dir zugewiesen. Änderungen nimmt die zuständige Planung vor.
    </p>

    <div class="detail-actions">
      <button mat-button (click)="closeDetail()">Schließen</button>
      <ng-container *ngIf="detail.kind === 'outlook'">
        <button mat-stroked-button (click)="hide(detail)" [disabled]="saving">
          <mat-icon>visibility_off</mat-icon> Vorschlag ausblenden
        </button>
        <button mat-flat-button color="primary" (click)="adopt(detail)" [disabled]="saving">
          <mat-icon>event_available</mat-icon> In Planung übernehmen
        </button>
      </ng-container>
      <a mat-stroked-button *ngIf="detail.kind === 'absence'" routerLink="/ressourcenplanung/abwesenheiten">
        Zu den Abwesenheiten
      </a>
    </div>
  </div>
</div>

<!-- Planungseditor (derselbe wie in der Teamplanung, ohne Outlook-Versand) -->
<div class="v2-modal-overlay" *ngIf="editorOpen && editingAssignment" (click)="closeEditor()">
  <div class="v2-modal-dialog" role="dialog" aria-modal="true" aria-label="Termin bearbeiten" (click)="$event.stopPropagation()">
    <app-resource-assignment-editor [assignment]="editingAssignment" [employees]="employees"
      [allAssignments]="assignments" [categories]="editorCategories" [saving]="saving"
      [customers]="context?.customers ?? []" [plants]="context?.equipments ?? []" [allowOutlookInvitation]="false"
      (saved)="saveAssignment($event)" (deleted)="deleteAssignment($event)" (closed)="closeEditor()">
    </app-resource-assignment-editor>
  </div>
</div>
